import { useEffect, useRef, useState } from "react";
import { api, punchSuljettu, punchinLuokka, type Liite, type Punch } from "./api";
import { naytaHitsinumero } from "./HitsiTunnus";
import { Pienoiskuva, onKuva } from "./KuvaIkkuna";
import { t } from "./kieli";

/* ═══════════════════════════════════════════════════════════
   Linjan avoimet punchit asiakkaan edustajalle näytettäväksi
   (Toni 17.10.2026 klo 07.35 ja 07.40 kohta 1).

   Linjatarkastuksen hyväksyntäosion ilmoitus «N luokittelematonta
   avointa punchia» avaa tämän saman sivun päälle (<dialog>), joten
   täytetty lomake ei katoa. Kentät: hitsi / nasta, siistitty teksti,
   luokka ja kuvat. EI nimiä (huomioinut, kuitannut, hoitaja, vastuu),
   ei sisäistä muistiinpanoa (huomiot) eikä isäntäjärjestelmää.
   ═══════════════════════════════════════════════════════════ */

/** Punchin teksti ilman henkilönimeä: SharePoint-tuonnin teksti voi päättyä «(Nimi, 2026-08-21 …)», ja se poistetaan aina —
 *  punchinTeksti poistaa sen vain, kun huomioija ja päivä ovat kentissä. Lisäksi «· prio X» -häntä luokan kanssa. */
export function punchinTekstiNimetta(p: { vika: string; luokka?: string | null }): string {
  let s = p.vika.replace(/\s*\([^(),]{2,60},\s*\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2})?)?\)\s*$/, "");
  if (p.luokka) s = s.replace(/\s*·\s*prio\s*\S+[^·]*$/i, "");
  return s.trim();
}

export function LinjanPunchPaneeli({ punchit, sulje }: { punchit: Punch[]; sulje: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);
  const avoimet = punchit.filter((p) => !punchSuljettu(p));
  const [kuvat, setKuvat] = useState<Record<number, Liite[]>>({});
  useEffect(() => { const d = ref.current; if (d && !d.open) d.showModal(); }, []);
  useEffect(() => {
    // Kuvat vain punchiin, jolla niitä on (liitteita > 0); lataus kirjautuu avauslokiin kuten linkistä avaaminen.
    for (const p of avoimet) if ((p.liitteita ?? 0) > 0)
      api.liitteet("punch", p.id).then((l) => setKuvat((k) => ({ ...k, [p.id]: l.filter((x) => onKuva(x.mime)) }))).catch(() => {});
  }, []);   // kerran avattaessa
  const kiinni = () => { ref.current?.close(); sulje(); };
  return (
    <dialog ref={ref} className="ikkuna punchpaneeli" data-ltar-punchpaneeli={avoimet.length}
            onCancel={(e) => { e.preventDefault(); kiinni(); }}>
      <div className="ikkuna__sisalto">
        <div className="ikkuna__yla">
          <strong>{t("ltar.paneeli_otsikko", { n: avoimet.length })}</strong>
          <button type="button" className="ikkuna__sulje" onClick={kiinni} aria-label={t("hl.sulje")}>×</button>
        </div>
        {avoimet.length === 0 ? <p className="dim">{t("ltar.paneeli_tyhja")}</p> : (
          <ul className="punchpaneeli__lista">
            {avoimet.map((p) => {
              const lk = punchinLuokka(p.luokka);
              const missa = [
                naytaHitsinumero(p.hitsinumero) ? `${t("pc.hitsi_pieni")} ${naytaHitsinumero(p.hitsinumero)}` : null,
                p.nasta != null ? t("ltar.paneeli_nasta", { n: p.nasta }) : null,
                p.linjatarkastus_kohta ? `${t("ltar.otsikko")} ${p.linjatarkastus_kohta}` : null,
              ].filter(Boolean).join(" · ") || t("ltar.merkinta_kohta");
              return (
                <li key={p.id} data-ltar-paneeli-punch={p.id}>
                  <div>
                    {lk ? <span className={lk.tunnus === "A" ? "merkki merkki--vika" : "merkki"} style={{ marginRight: 6 }}>{lk.tunnus}</span>
                        : <span className="merkki" style={{ marginRight: 6 }}>{t("ltar.paneeli_luokaton")}</span>}
                    <span data-ltar-paneeli-teksti="">{punchinTekstiNimetta(p)}</span>
                  </div>
                  <div className="dim">{missa}</div>
                  {(kuvat[p.id] ?? []).length > 0 && (
                    <div className="punchpaneeli__kuvat">
                      {/* Tiedostonimi voi sisältää nimen: paneelissa yleinen kuvateksti. */}
                      {kuvat[p.id]!.map((l, i) => <Pienoiskuva key={l.id} id={l.id} nimi={`${t("pu.kuvat")} ${i + 1}`} />)}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </dialog>
  );
}
